<template>
  <div
    :class="[
      $style.PFModalDualCardContainer,
      {
        [$style.PFModalDualCardContainerIsDark]: isDark,
      }
    ]"
  >
    <div :class="$style.PFModalDualCardItem">
      <div :class="$style.PFModalDualCardItemButton">
        <header :class="$style.PFModalDualCardItemButtonHeader">
          <WhatsAppIcon
            :class="$style.PFModalDualCardItemButtonHeaderIcon"
            style="color: var(--pf-modal-whatsapp-color);"
          />
          <span :class="$style.PFModalDualCardItemButtonHeaderText">
            Whatsapp
          </span>
        </header>
        <footer :class="$style.PFModalDualCardItemButtonFooter">
          <ActionTypeModalPreviewButton style="background-color: var(--pf-modal-whatsapp-color) !important;">
            {{ whatsappButtonText }}
          </ActionTypeModalPreviewButton>
        </footer>
      </div>

      <div
        v-if="previewType === 'desktop'"
        :class="$style.PFModalDualCardItemQrcode"
      >
        <header
          :class="$style.PFModalDualCardItemQrcodeHeader"
          style="color: var(--pf-modal-whatsapp-color);"
        >
          {{ whatsappQrcodeText }}
        </header>
        <footer :class="$style.PFModalDualCardItemQrcodeFooter">
          <img
            :class="$style.PFModalDualCardItemQrcodeFooterImg"
            src="https://widget.yourgood.app/api/settings/whatsapp/qr-preview?id=5a7fc0f5-4113-4a6c-9637-83f98a11611c&wid=59824863&p=%2B79289082585&m=%D0%97%D0%B4%D1%80%D0%B0%D0%B2%D1%81%D1%82%D0%B2%D1%83%D0%B9%D1%82%D0%B5!%20%D0%95%D1%81%D1%82%D1%8C%20%D0%B2%D0%BE%D0%BF%D1%80%D0%BE%D1%81%20%D0%BF%D0%BE%20%D0%B2%D0%B8%D0%B4%D0%B6%D0%B5%D1%82%D1%83%2C%20%D0%BD%D0%BE%D0%BC%D0%B5%D1%80%20%D0%BC%D0%BE%D0%B5%D0%B9%20%D0%B7%D0%B0%D1%8F%D0%B2%D0%BA%D0%B8%20-%20%20%2059824863%20"
            alt=""
          >
        </footer>
      </div>
    </div>

    <div :class="$style.PFModalDualCardItem">
      <div :class="$style.PFModalDualCardItemButton">
        <header :class="$style.PFModalDualCardItemButtonHeader">
          <TelegramIcon
            :class="$style.PFModalDualCardItemButtonHeaderIcon"
            style="color: var(--pf-modal-telegram-color);"
          />
          <span :class="$style.PFModalDualCardItemButtonHeaderText">
            Telegram
          </span>
        </header>
        <footer :class="$style.PFModalDualCardItemButtonFooter">
          <ActionTypeModalPreviewButton style="background-color: var(--pf-modal-telegram-color) !important;">
            {{ telegramButtonText }}
          </ActionTypeModalPreviewButton>
        </footer>
      </div>

      <div
        v-if="previewType === 'desktop'"
        :class="$style.PFModalDualCardItemQrcode"
      >
        <header
          :class="$style.PFModalDualCardItemQrcodeHeader"
          style="color: var(--pf-modal-telegram-color);"
        >
          {{ telegramQrcodeText }}
        </header>
        <footer :class="$style.PFModalDualCardItemQrcodeFooter">
          <img
            :class="$style.PFModalDualCardItemQrcodeFooterImg"
            src="https://widget.yourgood.app/api/settings/telegram/qr-preview?id=5a7fc0f5-4113-4a6c-9637-83f98a11611c&wid=59824863&p=YourgoodWidget_bot"
            alt=""
          >
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * UI
 */
import ActionTypeModalPreviewButton from '@/components/Actions/ActionPreview/ActionTypeModalPreview/ActionTypeModalPreviewButton.vue'
/**
 * Static
 */
import TelegramIcon from '@/assets/icons/TelegramIcon.svg?inline'
import WhatsAppIcon from '@/assets/icons/WhatsAppIcon.svg?inline'

export default {
  components: {
    ActionTypeModalPreviewButton,
    TelegramIcon,
    WhatsAppIcon
  },
  props: {
    previewType: {
      type: String,
      default: 'desktop'
    },
    extraTextEnabled: {
      type: Boolean,
      default: false
    },
    whatsappButtonText: {
      type: String,
      default: ''
    },
    whatsappQrcodeText: {
      type: String,
      default: ''
    },
    telegramButtonText: {
      type: String,
      default: ''
    },
    telegramQrcodeText: {
      type: String,
      default: ''
    },
    isDark: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style module lang="scss">
.PFModalDualCardContainer {
  all: unset;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);

  &:not(.PFModalDualCardContainerIsDark) {
    .PFModalDualCardItemButtonHeaderText {
      color: var(--primary);
    }

    .PFModalDualCardItem {
      border-color: var(--grey-200);
    }
  }

  &.PFModalDualCardContainerIsDark {
    .PFModalDualCardItemButtonHeaderText {
      color: var(--white);
    }

    .PFModalDualCardItem {
      border-color: var(--grey-800);
    }
  }
}

.PFModalDualCardItem {
  all: unset;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: calc(32px * var(--pf-modal-scale));
  background-color: transparent;
  border-width: 0;
  box-sizing: border-box;
  padding-right: calc(16px * var(--pf-modal-scale));
}

.PFModalDualCardItem + .PFModalDualCardItem {
  border-left-width: 1px;
  border-style: solid;
  padding-left: calc(16px * var(--pf-modal-scale));
  padding-right: 0;
}

.PFModalDualCardItemButton {
  all: unset;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: calc(16px * var(--pf-modal-scale));
}

.PFModalDualCardItemButtonHeader {
  all: unset;
  display: flex;
  align-items: center;
  gap: calc(8px * var(--pf-modal-scale));
}

.PFModalDualCardItemButtonHeaderIcon {
  --s: calc(32px * var(--pf-modal-scale));

  all: unset;
  display: inline-flex;
  width: var(--s);
  height: var(--s);
  color: currentColor;
}

.PFModalDualCardItemButtonHeaderText {
  all: unset;
  display: inline-block;
  font-family: 'Roboto', sans-serif !important;
  font-style: normal;
  font-weight: 500;
  font-size: calc(20px * var(--pf-modal-scale));
  line-height: calc(32px * var(--pf-modal-scale));
  letter-spacing: calc(0.15px * var(--pf-modal-scale));
}

.PFModalDualCardItemQrcode {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: calc(16px * var(--pf-modal-scale));
}

.PFModalDualCardItemQrcodeFooter {
  all: unset;
  display: inline-flex;
  aspect-ratio: 1 / 1;
  max-width: calc(160px * var(--pf-modal-scale));
}

.PFModalDualCardItemQrcodeFooterImg {
  all: unset;
  display: inline-flex;
  object-fit: fill;
  width: 100%;
  height: 100%;
  background-color: var(--white);
  border-radius: calc(8px * var(--pf-modal-scale));
}

.PFModalDualCardItemQrcodeHeader {
  all: unset;
  display: inline-flex;
  user-select: none;
  font-family: 'Roboto', sans-serif !important;
  font-style: normal;
  font-weight: 400;
  font-size: calc(16px * var(--pf-modal-scale));
  line-height: calc(19px * var(--pf-modal-scale));
  word-wrap: anywhere !important;
  max-width: 100%;
  text-align: center;
}
</style>
